import React from 'react'

import BaseSelectPanel from './BaseSelectPanel'
import JobSelectModal from '@pc/components/Works/Panel/selectModal/JobSelectModal'
import EmphasisHeading from '@pc/components/Works/Panel/shared/heading/EmphasisHeading'
import ButtonGroup from '@pc/components/Works/Panel/shared/button/ButtonGroup'
import ConditionParagraph from '@pc/components/Works/Panel/shared/ConditionParagraph'

import buildConditionWords from '@pc/components/Works/Panel/util/buildConditionWords'
import type { SearchParamsAttributes, ConditionReducer } from '@pc/components/Works/Panel/type'

interface PropsType {
  params: SearchParamsAttributes
  conditionReducer: ConditionReducer
}

const JobSelectPanel = (props: PropsType) => {
  const { params, conditionReducer } = props
  const jobTitles = [conditionReducer.attributes.condition_title_maps.job_codes, conditionReducer.attributes.condition_title_maps.job_type_ids]
    .flat()
    .filter((v): v is string => v != null)

  return (
    <BaseSelectPanel>
      <EmphasisHeading>職種</EmphasisHeading>
      <ConditionParagraph>{buildConditionWords(jobTitles)}</ConditionParagraph>
      <ButtonGroup>
        <JobSelectModal params={params} />
      </ButtonGroup>
    </BaseSelectPanel>
  )
}

export default JobSelectPanel
